import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectIsByHomeowner = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('is_by_homeowner')(jsonQuery),
);
